import React from "react";
import { Typography, Box } from "@mui/material";
import Progress from "../Progress";

const PageContent = ({ children, title, step = -1 }) => {
  return (
    <Box mt={2} mb={2}>
      {step >= 0 && <Progress step={-1} />}

      <Typography mb={1} variant="h4">
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default PageContent;
